import React, { useMemo } from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import LineKeySkeletonIcon from 'components/Luxkit/Icons/line/LineKeySkeletonIcon'

interface Props {
  offer: App.CarHireOffer;
  onViewInclusions: () => void;
}

function CarHireOfferTileInclusions(props: Props) {
  const { offer, onViewInclusions } = props

  const { inclusionsList, totalInclusions } = useMemo(() => {
    const inclusions = [...offer.copy.inclusions]

    inclusions.sort((inclusion) => {
      if (inclusion.toLowerCase().includes('additional driver')) return -2
      if (inclusion.toLowerCase().includes('fee')) return -1
      return 0
    })

    inclusions.unshift(offer.mileage.unlimited ? 'Unlimited mileage' : `${offer.mileage.quantity}${offer.mileage.unit}/${offer.mileage.period} rental mileage limit`)

    return {
      inclusionsList: inclusions.slice(0, 3),
      totalInclusions: inclusions.length,
    }
  }, [offer])

  return <VerticalSpacer gap={4}>
    {inclusionsList.length > 0 && <>
      {inclusionsList.map((inclusion, index) =>
        <Group
          direction="horizontal"
          gap={4}
          verticalAlign="center"
          key={inclusion}
        >
          {index === 0 && <LineKeySkeletonIcon colour="highlight-secondary"/>}
          {index !== 0 && <LineCheckIcon />}
          <BodyText variant="medium" colour={index === 0 ? 'highlight-secondary' : 'neutral-two'}>{inclusion}</BodyText>
        </Group>,
      )}
    </>}
    <TextLink size="medium" onClick={onViewInclusions}>
      {totalInclusions > 3 ? `+${totalInclusions - 3} more` : 'View all details'}
    </TextLink>
  </VerticalSpacer>
}

export default CarHireOfferTileInclusions
